import axios from "axios";
import type { AppDispatch } from "./store";
import {
  login,
  logout,
  setPaymentVolume,
  setStats,
  setUserProfile,
} from "./slices/authSlice";

type LoginPayload = {
  email: string;
  password: string;
};

export function checkAutoLogin(dispatch: AppDispatch): void {
  const tokenDetailString = localStorage.getItem("token");

  if (!tokenDetailString) {
    return;
  }

  axios.defaults.headers.common.Authorization = `Bearer ${tokenDetailString}`;

  axios
    .get("/v1/admin/profile")
    .then((res) => {
      dispatch(setUserProfile(res.data.data));
    })
    .catch((e) => {
      console.log(e);
    });

  axios
    .get("/v1/admin/dashboard-stats")
    .then((res) => {
      dispatch(setStats(res.data.data));
    })
    .catch((e) => {
      console.log(e);
    });

  axios
    .get("/v1/admin/payment-volume")
    .then((res) => {
      dispatch(setPaymentVolume(res.data.data));
    })
    .catch((e) => {
      console.log(e);
    });
}

export function LOGOUT_USER(dispatch?: AppDispatch): void {
  localStorage.removeItem("token");

  if (dispatch) {
    dispatch(logout());
  }
}

export function LOGIN_USER(payload: LoginPayload, dispatch: AppDispatch) {
  return new Promise((resolve, reject) => {
    axios
      .post("v1/admin/login", payload)
      .then((res) => {
        resolve(res);
        localStorage.setItem("token", res.data.data.token);
        dispatch(login(res.data.data));
      })
      .catch((e) => {
        reject(e);
        console.log(e);
      });
  });
}
